import {Banner} from '@shipwell/shipwell-ui';
import {is404Error} from 'App/utils/errors';

export const OrderErrorBanner = ({error}: {error: unknown}) => {
  if (is404Error(error)) {
    return <Banner title="Order not found">The order you&apos;re looking for doesn&apos;t exist.</Banner>;
  }
  return <Banner title="Error">There was an error. Try reloading the page.</Banner>;
};
